<template>
  <!-- 业务员角色 -->
  <div class="salesmanRole">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="业务员状态"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="未启用" value="1"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="userName"
        show-overflow-tooltip
        label="业务员姓名"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        prop="roleName"
        label="角色名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="addTime"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="bindRole(scope.row)"
            >绑定角色</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      title="角色选择"
      :searchValue="searchFormRole.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageRole"
      :allPage="allPageRole"
      @search="getRoleList"
      @rowClick="rowClick"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "salesmanRole",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        name: "",
        status: "9",
      },
      // 选择数据弹框
      dialogVisible: false,
      currPageRole: 1,
      allPageRole: 0,
      searchFormRole: {
        id: "",
        entId: "",
        name: "",
      },
      tableList: [],
      tableHead: {},
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetSalesManRole",
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "proc_dkxd_salesman"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "salesmanOrder/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                id: res.data[i].userId,
                userName: res.data[i].username,
                name: res.data[i].name,
                entId: res.data[i].entId,
                entName: res.data[i].entname,
                roleName: res.data[i].RoleName,
                addTime: res.data[i].add_time,
                status: res.data[i].status,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**绑定区域 */
    bindRole(row) {
      this.searchFormRole.id = row.id;
      this.searchFormRole.entId = row.entId;
      this.getRoleList("");
    },
    // 获取角色
    getRoleList(val, isRep) {
      this.searchFormRole.name = isRep ? val : this.searchFormRole.name;
      let data = {
        type: "GetYwtRole",
        spid: this.searchFormRole.id,
        xentId: this.searchFormRole.entId,
        strWhere: this.searchFormRole.name,
        PageIndex: this.currPageRole,
        PageSize: 10,
      };
      let proc = "proc_dkxd_salesman"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableHead = res.fdname;
            this.allPageRole = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 选择单条数据 绑定角色
    rowClick(row) {
      let data = {
        type: "UpdateSalesManRole",
        keyid: row.KeyId,
        ywyid: this.searchFormRole.id,
        xentId: this.searchFormRole.entId,
      };
      let proc = "proc_dkxd_salesman"; // 存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.salesmanRole {
  width: 100%;
  height: 100%;
}
</style>
